module.exports = __webpack_public_path__ + "static/image/service/font.ver2_0_2.gif?6a974086";